import React from 'react'

import logo from '../../assets/img/entradas.png'

const EntradasImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Entradas' style={{ width: '100%' }} />
  </div>
)

export default EntradasImage